import { computed } from 'vue';
import { rawDynamicImport } from '@app/helpers/memberships/section';
import { data } from '../../../store'

export default function (validate, form) {
    return {
        title: 'Tickets',
        component: rawDynamicImport(() => import('@app/booking/components/form/stages/tickets/Tickets.vue')),
        isValid: computed(
            () => validate({
                'ticket.quantity': ['required', 'integer', 'min:1'],
                'ticket.ticket.id': ['required'],
            })
        ),
        data: computed(
            () => {
                const memberType = form.value.ticket?.ticket?.cheapest_price_member_type

                const defaultMemberType = data.member.details.value?.individual_member !== null
                    ? 'individual'
                    : 'organisation';

                return {
                    event_id: data.event.details.value.id,
                    ticket: {
                        quantity: form.value.ticket?.quantity,
                        ticket_id: form.value.ticket?.ticket?.id,
                        cost: form.value.ticket?.ticket?.cheapest_price?.price,
                        event_price_id: form.value.ticket?.ticket?.cheapest_price?.id,
                    },
                    member: {
                        type: memberType !== null
                            ? memberType
                            : (data.member.details.value?.id ? defaultMemberType : null)
                    },
                    payment: {
                        redirect: window.location.href,
                    },
                }

            }
        ),
    }
}